/** @file menuRegistry: every context-menu row of the editor, declared once per subject. */
import { CLIP_ENTRIES } from './clipEntries';
import { KEY_ENTRIES } from './keyEntries';
import { NODE_ENTRIES } from './nodeEntries';
import type { MenuCtxOf, MenuEntry, MenuSubject } from './registryTypes';
import { SLOT_ENTRIES } from './slotEntries';
import { SPACE_ENTRIES } from './spaceEntries';

/**
 * The rows per subject. A joint right-clicked in the viewport and its row in the tree share one list, so they show
 * the same rows in the same order; `buildMenu` turns a list into the items the context-menu layer draws.
 */
export const menuRegistry: { [S in MenuSubject]: MenuEntry<MenuCtxOf[S]>[] } = {
  joint: NODE_ENTRIES,
  'node-row': NODE_ENTRIES,
  'viewport-space': SPACE_ENTRIES,
  clip: CLIP_ENTRIES,
  key: KEY_ENTRIES,
  slot: SLOT_ENTRIES,
};
